import { createFileRoute, redirect } from '@tanstack/react-router'

import { ExternalPageHeader } from '@/components/layout/external-page-header'
import { SignUpForm } from '@/features/authentication/components/signup-form'

export const Route = createFileRoute('/signup')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/' })
    }
  },
  component: Signup,
})

function Signup() {
  return (
    <div className="relative flex min-h-screen flex-col bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 dark:from-slate-900 dark:via-emerald-900/20 dark:to-teal-900/20">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-emerald-500/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-teal-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <ExternalPageHeader />

      <main className="relative z-10 flex flex-1 items-center justify-center px-4 py-10 text-slate-900 dark:text-slate-100">
        <div className="w-full max-w-md">
          <SignUpForm />
          <footer className="mt-8 text-center text-xs text-slate-700 dark:text-slate-300">
            <p>© 2025 UIBFS. All rights reserved.</p>
          </footer>
        </div>
      </main>
    </div>
  )
}
